import React from 'react'
import '../styles/home.css'
import Work from '../components/Work'
import { Link } from 'react-router-dom'
import { Nav } from '../components/Nav'

const Home = () => {
    return (
        //  <div className='vertical-gradient texture1'></div>
        <div>
            <Nav />
            <div id="home-img-container">
                <img src='images/bg.png' style={{ width: '100%' }} />
                <div id='db'>
                    <h1 id='db1'>Dawson Bolen</h1>
                    <h2 >Design / Development</h2>
                </div>


            </div>

            <div id='title-mobile'>

                <img src='images/headshot.png' />

                <div>
                    <h1>Dawson Bolen</h1>
                    <h2 >Design / Development</h2>
                </div>
            </div>

            <div id="home-cards">

                <div id="contactcards">
                    <div className="card contact-card-format">
                        <a className="contact-top-links" href="mailto: dawson120@live.com">
                            <div className="contactlinks">
                                <div className="contactlinks-row1">
                                    <img src={process.env.PUBLIC_URL + "/images/emailicon.png"} width="100px" height="100px" alt="email icon"></img>
                                </div>
                                <div className="contactlinks-row2">
                                    <h2>Email</h2>
                                    <p>dawson120@live.com</p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="card contact-card-format">
                        <a className="contact-top-links" href="tel:4257499555">
                            <div className="contactlinks">
                                <div className="contactlinks-row1">
                                    <img src={process.env.PUBLIC_URL + "/images/smartphoneicon.png"} width="100px" height="100px" alt="phone icon"></img>
                                </div>
                                <div className="contactlinks-row2">
                                    <h2>Phone</h2>
                                    <p>425-749-9555</p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="card contact-card-format">
                        <a class="contact-top-links" href="https://www.linkedin.com/in/dawsonbolen/">
                            <div className="contactlinks">
                                <div className="contactlinks-row1">
                                    <img src={process.env.PUBLIC_URL + "/images/linkedinicon.png"} width="100px" height="100px" alt="linkedin icon"></img>
                                </div>
                                <div className="contactlinks-row2">
                                    <h2>Linkedin</h2>
                                    <p>Dawson Bolen</p>
                                </div>
                            </div>
                        </a>
                    </div>

                </div>


            </div>

            <section id='abt-home'>
                {/* <img id='portrait' src='images/headshot.png' width='300px' /> */}

                <img id='portrait' src='images/portrait.png' />
                <div>
                    <h2 id='abt-me'>HI I'M <span id='dawson'>DAWSON</span></h2>
                    <p>I'm a fullstack developer and designer who specializes in creating visually striking, user-centered websites. With a strong background in UX/UI design, I blend creativity and functionality to craft engaging digital experiences. </p>
                    <Link to='/about'>
                        <button className='glow-box-btn btn-main'> Learn More</button>
                    </Link>

                </div>
            </section>


            <section className='circuit-texture' id='home-s2'>
                <div className='filter-isolate' style={{ display: 'flex', justifyContent: 'center' }}>
                    {/* <h2 className='heading2 mt-20 mb-20'>MY SKILLS</h2> */}

                    <div class="glow-wrapper alt-head-txt">
                        <span class="glow-text">My SKILLS</span>
                        <span class="stroke-text">MY SKILLS</span>
                    </div>
                </div>



                <div className='skills-cont'>

                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/htmlicon.png' />
                        </div>
                        <h3>HTML</h3>
                    </div>

                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/cssicon.png' />
                        </div>
                        <h3>CSS</h3>
                    </div>

                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/sassicon.png' />
                        </div>
                        <h3>SASS</h3>
                    </div>


                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/javascripticon.png' />
                        </div>
                        <h3>JavaScript</h3>
                    </div>


                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/typescripticon.png' />
                        </div>
                        <h3>TypeScript</h3>
                    </div>


                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/bootstrapicon.png' />
                        </div>
                        <h3>Bootstrap</h3>
                    </div>

                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/reacticon.png' />
                        </div>
                        <h3>React</h3>
                    </div>


                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/angular-icon.png' />
                        </div>
                        <h3>Angular</h3>
                    </div>


                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/redux-icon.png' />
                        </div>
                        <h3>Redux</h3>
                    </div>

                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/nodeicon.png' />
                        </div>
                        <h3>Node JS</h3>
                    </div>


                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/pythonicon.png' />
                        </div>
                        <h3>Python</h3>
                    </div>


                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/java-icon.png' />
                        </div>
                        <h3>Java</h3>
                    </div>

                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/springbooticon.png' />
                        </div>
                        <h3>Spring Boot</h3>
                    </div>


                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/sqlicon.png' />
                        </div>
                        <h3>SQL</h3>
                    </div>

                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/mongodbicon.png' />
                        </div>
                        <h3>Mongo DB</h3>
                    </div>


                    {/* <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/phpicon.png' />
                        </div>
                        <h3>PHP</h3>
                    </div> */}

                    {/* 
                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/gqlicon.png' />
                        </div>
                        <h3>Graph QL</h3>
                    </div> */}


                    {/* <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/wpicon.png' />
                        </div>
                        <h3>WordPress</h3>
                    </div> */}

                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/awsicon.png' />
                        </div>
                        <h3>AWS</h3>
                    </div>


                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/gcpicon.png' />
                        </div>
                        <h3>GCP</h3>
                    </div>



                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/aiicon.png' />
                        </div>
                        <h3>Illustrator</h3>
                    </div>

                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img src='images/apicon.png' />
                        </div>
                        <h3>Photoshop</h3>
                    </div>

                    <div className='skills-card glow-box xd'>
                        <div className='skills-card-icon'>
                            <img src='images/xdicon.png' />
                        </div>
                        <h3>XD</h3>
                    </div>

                    <div className='skills-card glow-box'>
                        <div className='skills-card-icon'>
                            <img id='figma' src='images/figmaicon.png' />
                        </div>
                        <h3>Figma</h3>
                    </div>



                </div>

            </section>

            <section id='work'>
                <div className='filter-isolate' style={{ display: 'flex', justifyContent: 'center' }}>
                    {/* <h2 className='heading2 mt-20 mb-20'>MY SKILLS</h2> */}

                    <div class="glow-wrapper alt-head-txt">
                        <span class="glow-text">PROJECTS</span>
                        <span class="stroke-text">PROJECTS</span>
                    </div>
                </div>
                <br />
                <br />
                <Work />
            </section>

            <br />
            <br />


            <br />
            <br />

        </div>
    )
}

export default Home